import uniqid from 'uniqid'
import i18n from '@/i18n'
import config from '@/utils/config'
import { getCookie } from '@/utils/utils'
import jwt from 'jsonwebtoken'
import session from '@/auth/session'


/**
 * Management token system
 */

/**
 * @type {Number} Expiration time
 */
const JWT_EXPIRE_TIME = 3 * 60 * 1000

/**
 * Creates a valid JWT from credentials
 * @param {*} credentials To parse
 * @return {String} JWT token
 */
function generateJWTfromCredentials (credentials) {
  let randomUniqToken = uniqid()

  let data = JSON.stringify({
    locale: i18n.locale,
    promEntityCode: config.promoterCode,
    registeredEntityNIF: credentials.user,
    token: randomUniqToken
  })

  let now = new Date()
  let exp = now.getTime() + JWT_EXPIRE_TIME

  let jsToken = jwt.sign({
    iss: config.promoterCode,
    iat: now.getTime(),
    sub: 'eFactura',
    scope: 'admins',
    exp,
    data
  }, config.jwtDecodeSecret, { algorithm: 'HS256' })

  return `${config.promoterCode}_${jsToken}`
}

export const token = {
  fromCookie: () => {
    let cookieToken = getCookie(config.jwtCookieName)
    session.setTokenAuth()
    return cookieToken
  },
  fromCredentials: (credentials) =>
    generateJWTfromCredentials(credentials)
}

/**
 * Creates an authorization request info
 * @param {*} params To be used
 * @return {Object} Info to be used as authorization
 */
export const createAuthRequest = (params = {}) => {
  let authorization = params.loginData
                          ? token.fromCredentials(params.loginData)
                          : session.getTokenAuth() || token.fromCookie()
  if (authorization) {
    session.setTokenAuth(authorization)
  }
  let options = {}
  return { authorization, options }
}

/**
 * Determine whether to crate an authorization request or not
 * @param {*} params To be used
 * @return {Boolean|Object} `false` if there is no need to create a request, in other case an object with request config
 */
export const createAuthRequestNew = (params = {}) => {
  return !params.loginData
    ? false
    : {
        grant_type: 'password',
        username: params.loginData.user,
        password: params.loginData.password,
        nif: params.loginData.nif.toUpperCase(),
        promoterCode: String(config.promoterCode)
      }
}

/**
 * Returns whether user is authenticated or not
 * @return {Boolean} True if session is valid, false in other case
 */
export const isAuthenticated = () => {
  const sessionToken = session.getToken()
  return (!(!sessionToken || session.isExternalSession()))
}

/**
 * Determines if session is from external source
 * @param   {*} externalToken Session token
 * @return  {Boolean} true if session is from external source, false in other case
 */
export const isExternalyAuthenticated = (externalToken) => {
  if (!externalToken) return false
  var payload = JSON.parse(atob(externalToken.split('.')[1]))
  let newData = {}
  if (typeof payload.data === 'object') {
    newData = { 'token': externalToken, 'userDocument': payload.data.registeredEntityNIF }
  } else {
    var data = JSON.parse(payload.data)
    newData = { 'token': externalToken, 'userDocument': data.registeredEntityNIF, 'language': data.locale }
  }
  session.save(newData, false, true)
  return true
}
